
import moment from 'moment';
import { getData, getTimestampData } from '@/components/report/service';
import {
  SiteDepartQuery,
  SiteDepartQueryDetails,
} from '../Sql';
import { SqlBase } from '../../../common';

const dateRange = [
  moment(new Date()).add(-14, 'days'),
  moment(new Date()).add(0, 'days')
]
export default {
  namespace: 'forecastCenterDepartBoardSiteDepartModal',
  state: {
    totalData: [],
    // 网点table
    page: 1, 
    siteData: [],

    // 点击网点查明细 / 类型
    // 明细
    siteDetailsData: [],
    // 类型
    siteProductData: [],

    dateRange: dateRange,
    modalVisible: false,
    modalType: '',
    modalTitle: '',
    dateType: undefined,
  },
  effects: {
    // 重置
    *setReset(_, { put }) {
      yield put({
        type: 'update',
        payload: {
          totalData: [],
          page: 1, 
          siteData: [], 
          siteDetailsData: [],
          siteProductData: [],
        },
      });
    },
    // 重置二级弹层
    *setResetModal(_, { put }) {
      yield put({
        type: 'update',
        payload: {
          dateRange: dateRange,
          modalVisible: false,
          dateType: undefined,
          siteDetailsData: [],
          siteProductData: [],
        },
      });
    },
    *getSelect(_, { put }) {
      yield put({ type: 'getSiteDetails' });
    },
    /**
     * 明细表格
    */
    *getSiteDetails(_, { call, put, select }) {
      let centerFilter = yield select(({ forecastCenterDepartBoard }) => forecastCenterDepartBoard.searchParams.centerFilter);
      let query = yield select(({ forecastCenterDepartBoardModals }) => {
        return {
          dateType: forecastCenterDepartBoardModals.dateType,
          startDate: moment(forecastCenterDepartBoardModals.dateRange[0]),
          endDate: moment(forecastCenterDepartBoardModals.dateRange[1])
        }
      });
      const filter = SiteDepartQuery({
        startDate: query.startDate.format('YYYY-MM-DD 12:00:00'),
        endDate: query.endDate.format('YYYY-MM-DD 12:00:00'),
        scanSite: centerFilter,
      });
      const params = {
        aggregators: SqlBase()
      }
      const data = yield call(getData, { ...params, ...filter[1] });
      data && data.forEach((item, index) => {
        item.index = index;
      });
      yield put({
        type: 'update',
        payload: {
          siteData: data || []
        },
      });
    },
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
  },
}